import { Img } from "containers/Manual/components/content/Image";
import { Paragraph } from "containers/Manual/components/content/Paragraph";
import { Li } from "containers/Manual/components/list/Li";
import { Ul } from "containers/Manual/components/list/Ul";
import { CardSection } from "containers/Manual/components/section/CardSection";
import { ListSection } from "containers/Manual/components/section/ListSection";

export const FROMUNIXTIME = () => {
  return (
    <CardSection id="FROMUNIXTIME" title="FROMUNIXTIME">
      <Paragraph>
        UNIX TIME STAMP에서 날짜/시간 객체를 반환합니다. 이는 MySQL
        FROM_UNIXTIME() 함수와 동일한 값을 제공합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>FROMUNIXTIME(MILLISECONDS)</Paragraph>
        <Ul>
          <Li>
            <b>MILLISECONDS</b>는 밀리초로 표시되는 int 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
      </ListSection>
    </CardSection>
  );
};
